import Head from "next/head";
import {
  PWA_APPLE_TITLE,
  PWA_MANIFEST_PATH,
  PWA_THEME_COLOR,
} from "@/lib/pwa/config";

export function PwaHead() {
  return (
    <Head>
      <link rel="manifest" href={PWA_MANIFEST_PATH} />
      <meta name="theme-color" content={PWA_THEME_COLOR} />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="apple-mobile-web-app-title" content={PWA_APPLE_TITLE} />
      <link rel="apple-touch-icon" href="/icons/apple-touch-icon.png" />
    </Head>
  );
}
